import styles from 'components/sections/search/BrandSearchResult.module.scss';
import {useEffect, useState} from "react";
import {captureException, captureMessage} from "@sentry/nextjs";
import {Axios} from "api";
import BrandSearchItemCard from "components/cards/search/BrandSearchItemCard";
import RecommendedQueries from "components/sections/search/RecommendedQueries";
import {KEY_BRAND} from "components/sections/search/SearchResult";
import NoSearchResult, {NoBrandSearchResult} from "components/sections/search/NoSearchResult";
import LoadingSearchResult, {SearchResultError} from "components/sections/search/LoadingSearchResult";


const BrandSearchResult = (props) => {
    const {query, setQuery, recommendedQueries} = props;
    const [brandList, setBrandList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasNoResult, setHasNoResult] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!query) {
            setBrandList([]);
            setHasNoResult(false);
        } else {
            fetchBrands(query);
        }
    }, [query]);

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewBrandSearchResult',
            {query},
        );
    }, []);

    const fetchBrands = async (query) => {
        try {
            setIsLoading(true);
            setError(false);
            const res = await Axios.get(`v1/search/brand`, {params: {query}});
            if (res.status < 400) {
                setBrandList(res.data.brands);
                setHasNoResult(res.data.brands.length === 0);
            } else {
                captureMessage(JSON.stringify(res.data));
                setError(true);
            }
        } catch (e) {
            alert('일시적인 오류가 발생했습니다. 고객센터로 문의해주세요.');
            captureException(e);
            setError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const onItemClick = (brand) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'BrandSearchResultItemClick',
            {
                brand: brand.name,
            }
        );
        props.onItemClick && props.onItemClick(brand);
    };

    const handleRefresh = () => {
        fetchBrands(query);
    };

    return (
        <div>
            {
                query
                    ?
                    (
                        error
                            ? <SearchResultError handleRefresh={handleRefresh}/>
                            : (
                                isLoading
                                    ? <LoadingSearchResult/>
                                    :
                                    (
                                        hasNoResult
                                            ? <NoBrandSearchResult query={query}/>
                                            :
                                            <>
                                                <div className={styles.container}>
                                                    <div className={styles.listContainer}>
                                                        {
                                                            brandList.map((brand) => {
                                                                return <BrandSearchItemCard
                                                                    brand={brand} key={brand.id}
                                                                    onClick={() => onItemClick(brand)}
                                                                    highlightKeyword={query}
                                                                />
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className={styles.bottomPadding} />
                                            </>
                                    )
                            )
                    )
                    :
                    <div className={styles.container}>
                        <RecommendedQueries
                            category={KEY_BRAND} searchQuery={setQuery}
                            recommendedQueries={recommendedQueries}
                        />
                    </div>
            }
        </div>
    );
};

export default BrandSearchResult;
